import { mapActions } from 'vuex'

export const editGeofenceMixin = {
  methods: {
    ...mapActions(['editGeoFence', 'setIsUpdatingFence']),
    async updateGeofenceFromMessage(editedPath) {
      this.setIsUpdatingFence(true)
      let updateObject = {
        id: this.selectedGeofence.id
      }
      if (this.editedName !== '' && (this.editedName !== this.selectedGeofence.name)) {
        updateObject = {
          ...updateObject,
          name: this.editedName
        }
      }
      if (editedPath.length > 0) {
        updateObject = {
          ...updateObject,
          path: editedPath
        }
      }
      const updatedFence = await this.editGeoFence(updateObject)
      if (updatedFence) {
        this.showCreateEditGeofenceAction(false)
        this.setIsUpdatingFence(false)
        this.editedName = ''
        this.setEditingGeofence(false)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/editGeofenceMixin.js